/** Ask Navi chat models — shape-compatible with `@brighthub/copilot` without importing that package. */

export interface Conversation {
  id: string;
  title: string;
  created_at: string;
  updated_at?: string;
  user_id?: string;
  metadata?: Record<string, unknown>;
  owner_id?: string;
  messages?: Message[];
}

export interface Message {
  id: string;
  conversation_id: string;
  content: string;
  role: MessageRole;
  created_at: string;
  traces?: Trace[];
  metadata?: Record<string, unknown>;
  owner_id?: string;
}

export enum MessageRole {
  USER = 'user',
  ASSISTANT = 'assistant',
  SYSTEM = 'system',
}

export interface Trace {
  index?: number;
  reasoning?: string;
  rationale?: string;
  toolUsage?: unknown;
  type?: string;
}
